/**
 * Wysyłanie rządania POST na wskazany adres URL
 *
 * @export
 * @param {string} url
 * @param {*} [body={}]
 * @returns {Promise<Response>}
 */
export function post(url: string, body = {}): Promise<Response> {
  return fetch(url, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  });
}
